import { get } from 'lodash'
import { maxLength, required } from 'utils/validation'

const validate = values => {
  let errors = {}

  errors = {
    mfaCode: required(get(values, 'mfaCode')) || maxLength(6)(get(values, 'mfaCode'))
  }

  return errors
}

export default validate
